import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

const CompletePage = () => {
  const [_isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const _handleBackClick = () => {
    navigate("/year-booking");
  };

  const handleCompleteClick = () => {
    // URL에 따라 다른 페이지로 이동
    if (location.pathname.includes("/event-booking/")) {
      navigate("/event-booking");
    } else {
      navigate("/year-booking");
    }
  };

  // URL에 따라 다른 제목과 설명 표시
  const isEventBooking = location.pathname.includes("/event-booking/");
  const completionTitle = isEventBooking
    ? "월단체 신청이 완료되었습니다!"
    : "연단체 신청이 완료되었습니다!";

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <OkPageContainer>
      <div className="main-content">
        <div className="content-container">
          <div className="illustration-container">
            <img
              className="completion-image"
              src={require("src/assets/images/complete.png")}
              alt="Application completion illustration"
            />
          </div>
          <h2 className="completion-title">{completionTitle}</h2>
          <p className="completion-description">
            신청하신 조건을 골프장에서 검토한 후에
            <br />
            <span style={{ color: "#007bff", fontWeight: "600" }}>
              "신청승낙 / 조건변경 / 신청거절"
            </span>
            을 앱내 통지드립니다.
          </p>
        </div>
      </div>

      <div className="bottom-section">
        <button className="completion-button" onClick={handleCompleteClick}>
          확인
        </button>
      </div>
    </OkPageContainer>
  );
};

const OkPageContainer = styled.div`
  :root {
    --teeshot-white: #fdfdfd;
    --teeshot-black: #1a1a1a;
    --teeshot-g1: #79818a;
    --teeshot-g2: #d1d5d8;
    --teeshot-green: #004b49;
    --teeshot-blue: #007bff;
  }

  background: var(--teeshot-white);
  position: relative;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0 auto;
  overflow: hidden;

  .nav-content {
    display: flex;
    padding: 4px 161px 4px 0;
    align-items: center;
    gap: 114px;
    flex: 1 0 0;
    align-self: stretch;
    position: relative;
  }

  .back-button {
    width: 48px;
    height: 48px;
    position: absolute;
    left: 0;
    top: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-icon-container {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-arrow {
    width: 10px;
    height: 16px;
  }

  .nav-title {
    color: var(--teeshot-black);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    position: absolute;
    left: 162px;
    top: 17px;
    width: 67px;
    height: 22px;
    margin: 0;
  }

  /* Main Content */
  .main-content {
    width: 100%;
    max-width: 390px;
    padding: 120px 48px 0;
    margin: 0 auto;
  }

  .content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .illustration-container {
    width: 192px;
    height: 192px;
    margin-bottom: 24px;
  }

  .completion-image {
    width: 192px;
    height: 192px;
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .completion-title {
    color: var(--teeshot-black);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    margin: 0 0 16px 0;
  }

  .completion-description {
    color: var(--teeshot-g1);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    margin: 0;
  }

  /* Bottom Section */
  .bottom-section {
    display: flex;
    width: 100%;
    max-width: 390px;
    padding: 26px 16px;
    justify-content: center;
    align-items: center;
    background: linear-gradient(0deg, var(--teeshot-white) 76.92%, rgba(253, 253, 253, 0) 100%);
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .completion-button {
    display: flex;
    width: 100%;
    max-width: 358px;
    height: 60px;
    padding: 19px 120px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: none;
    cursor: pointer;
    color: white;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    border-radius: 10px;
    background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
  }

  .completion-button:active {
    background: rgb(126, 130, 129);
  }

  @media (max-width: 768px) {
    width: 100vw;
    max-width: 390px;

    .status-bar,
    .top-navigation,
    .bottom-section {
      width: 100%;
    }

    .nav-title {
      left: calc(50% - 33.5px);
    }
  }
  .completion-description .textBlue {
    color: #007bff !important;
    font-weight: 700;
  }
`;

export default CompletePage;
